/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import type {ComponentPropsWithRef, ReactElement} from 'react'

/**
 * @public
 */
export function ListIcon(props: ComponentPropsWithRef<'svg'>): ReactElement {
  return (
    <svg
      data-sanity-icon="list"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 6.5H19M6 14.5H19M6 10.5H19M6 18.5H19"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export {ListIcon as default}
